module.exports = __webpack_public_path__ + "b799df741c74b7fc05a5a32715c8748c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/clean-chart.png
// module id = 1414
// module chunks = 0